import { parseJSON } from './parse-json';

const base64Decoder = <T extends object>(s: string): T | string => {
  const replaced = s.replace(/-/g, '/').replace(/_/g, '+');

  try {
    const binary = atob(replaced);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(bytes);

    // Проверяем, похожа ли строка на JSON (начинается с { или [)
    const trimmed = decoded.trim();
    const looksLikeJson = trimmed.startsWith('{') || trimmed.startsWith('[');

    if (looksLikeJson) {
      // Пытаемся распарсить как JSON
      const parsed = parseJSON<T>(decoded);
      // Если парсинг успешен, возвращаем объект
      if (parsed !== null) {
        return parsed;
      }
    }

    // Если парсинг не удался или строка не похожа на JSON, возвращаем исходную строку
    return decoded;
  } catch (err) {
    console.error('base64Decoder ERROR', err);
    // В случае ошибки декодирования base64, возвращаем пустой объект
    return {} as T;
  }
};

const base64Encoder = (payload: any) => {
  const json = JSON.stringify(payload ?? {});
  const utf8Bytes = new TextEncoder().encode(json);
  const base64 = btoa(String.fromCharCode(...utf8Bytes));
  const safe = base64.replace(/\//g, '-').replace(/\+/g, '_');
  return safe;
};

export const base64Utils = {
  decode: base64Decoder,
  encode: base64Encoder,
};
